import { DataMapperMapping } from 'app/model/adfDataMapper/dataMapperMapping';
import { IModel, IRelationship, Metamodel, Named} from 'shell-models-lib';
import { IMapperTable, IMapperConnectionInfo } from 'app/model/adfDataMapper/IMapperTable';
import { MapperConnection } from 'app/model/adfDataMapper/mapperConnection';

@Metamodel.model({
    name: 'MappingTargetConnectionInfo',
    display: [
        stringResources.MappingTargetConnectionInfo,
        stringResources.MappingTargetConnectionsInfo
    ]
})
export class MappingTargetConnectionInfo extends Named implements IMapperConnectionInfo {
    public static readonly MODEL: IModel;
    public connection: MapperConnection;

    public tables: IMapperTable[] = [];

    public readonly dataMapperMappings: DataMapperMapping[] = [];

    public readonly relationships: IRelationship[] = [];

    constructor(connection?: MapperConnection, tables?: IMapperTable[], dataMapperMapping?: DataMapperMapping[], relationships?: IRelationship[]){
        super();
        this.connection = connection;
        this.tables = !!tables ? tables: [];
        this.dataMapperMappings = !!dataMapperMapping ? dataMapperMapping : [];
        this.relationships = !!relationships ? relationships : [];
    }
}
